// controllers/guardian_modal_controller.js
import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["container"]
  static values = { eventId: Number }

  open(event) {
    console.log('open')
    const id = event.currentTarget.dataset.id

    fetch(`/admin/events/${this.eventIdValue}/guardians/${id}`, {
      headers: { "Accept": "text/html" }
    })
        .then(res => res.text())
        .then(html => {
          this.containerTarget.innerHTML = html

          const modalEl = this.containerTarget.querySelector(".modal")
          const modal = new Modal(modalEl)

          modal.show()

          // Clean up after close
          modalEl.addEventListener("hidden.bs.modal", () => {
            this.containerTarget.innerHTML = ""
          })
        })
  }
}